import {DEFAULT_PAGE_NUMBER, ORDER, SORT_FIELDS as COMMON_SORT_FIELDS} from '../base.js'

export const PAGE_TYPES = {
  AD: 'ad',
  STOCK: 'stock'
}
export const PRIVATE_CONTRACT_ID = 1

export const HAS_PHONE_TRACKING_ACTIVE = false

export const DEALER_PACKS = {
  SUBSCRIPTION: 'subscription'
}

export const DEALER_TYPES = {
  ALL: 'ALL',
  ONLINE: 'ONLINE',
  PHYSICAL: 'PHYSICAL'
}

export const SELLER_TYPE_PROFESSIONAL = 1

export const SELLER_TYPE_PRIVATE = 2

export const SIMILAR_DEALERS_SIZE = 10

export const DEFAULT_SEARCH = {
  page: DEFAULT_PAGE_NUMBER,
  sortBy: COMMON_SORT_FIELDS.RELEVANCE,
  sortOrder: ORDER.DESC
}

export const RANDOM_SEARCH = {
  page: DEFAULT_PAGE_NUMBER,
  sortBy: COMMON_SORT_FIELDS.RANDOM
}

export const RATINGS_CANCEL_TRADE_STATUS = {
  CANCELLED: 'cancelled'
}

export const DEALERS_IN_PROVINCES_ENABLED = false
